import Panel from '@admin/components/panel'
import UserToken from '@admin/tokens/user'
import Feed from '@admin/components/feed'
import AppToken from '@admin/tokens/app'

const mapPropsToPanel = (props, context) => ({
  title: 't(Activities)',
  collection: {
    endpoint: '/api/admin/platform/activities',
    criteria: {
      fields: [
        { label: 'item', fields: [
          { name: 'User', key: 'user_id', type: 'select', multiple: true, endpoint: '/api/admin/team/users', valueKey: 'id', textKey: 'full_name', sort: { key: 'last_name', order: 'asc' }, format: UserToken },
          { name: 'App', key: 'app_id', type: 'select', multiple: true, endpoint: '/api/admin/team/apps', valueKey: 'id', textKey: 'title', sort: { key: 'code', order: 'asc' }, format: AppToken },
          { name: 'Date Range', key: 'date', type: 'daterange', include: ['this','last'] }
        ] }
      ]
    },
    export: [
      { label: 't(ID)', key: 'id' },
      { label: 't(Date)', key: 'created_at' },
      { label: 't(User)', key: 'user.full_name' },
      { label: 't(App)', key: 'app.title' },
      { label: 't(Description)', key: 'description' }
    ],
    defaultSort: { key: 'created_at', order: 'desc' },
    empty: {
      svg: 'activity',
      title: 't(No Activities)',
      text: 't(We have not yet recorded any activities)'
    },
    entity: 'activity',
    layout: Feed
  }
})

export default Panel(null, mapPropsToPanel)
